(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baldwin-home-video-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-bw-hvs]');
  roots.forEach(function (root) {
    var track = root.querySelector('[data-hvs-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hvs-card]'));
    var dotsWrap = root.querySelector('[data-hvs-dots]');
    var prev = root.querySelector('.bw-hvs__nav--prev');
    var next = root.querySelector('.bw-hvs__nav--next');
    if (!track || !cards.length) return;

    var vids = root.querySelectorAll('video');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (!video.src && video.dataset.src) video.src = video.dataset.src;
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.55 });
    vids.forEach(function (video) { io.observe(video); });

    function isControl(target) {
      return Boolean(target && target.closest && target.closest('.bw-hvs__sound, .bw-hvs__nav, .bw-hvs__dot, button, a'));
    }

    root.querySelectorAll('.bw-hvs__sound').forEach(function (btn) {
      btn.addEventListener('pointerdown', function (event) {
        event.stopPropagation();
      });
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var video = btn.closest('.bw-hvs__media').querySelector('video');
        if (!video.src && video.dataset.src) video.src = video.dataset.src;
        vids.forEach(function (other) {
          if (other !== video) other.muted = true;
        });
        root.querySelectorAll('.bw-hvs__sound').forEach(function (otherBtn) {
          if (otherBtn !== btn) otherBtn.innerHTML = '&#128263;';
        });
        video.muted = !video.muted;
        btn.innerHTML = video.muted ? '&#128263;' : '&#128266;';
        if (!video.muted) video.play().catch(function () {});
      });
    });

    cards.forEach(function (card, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'bw-hvs__dot';
      dot.setAttribute('aria-label', 'Video ' + (index + 1));
      dot.addEventListener('click', function () { scrollTo(index); });
      dotsWrap.appendChild(dot);
    });

    function currentIndex() {
      var left = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, index) {
        var dist = Math.abs(card.offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = index;
        }
      });
      return best;
    }

    function scrollTo(index) {
      var card = cards[Math.max(0, Math.min(index, cards.length - 1))];
      track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
    }

    function syncDots() {
      var index = currentIndex();
      dotsWrap.querySelectorAll('.bw-hvs__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    track.addEventListener('scroll', syncDots, { passive: true });
    if (prev) prev.addEventListener('click', function () { scrollTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollTo(currentIndex() + 1); });

    var drag = { active: false, startX: 0, startLeft: 0, moved: false };
    track.addEventListener('pointerdown', function (event) {
      if (event.button && event.button !== 0) return;
      if (isControl(event.target)) return;
      drag.active = true;
      drag.moved = false;
      drag.startX = event.clientX;
      drag.startLeft = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (event) {
      if (!drag.active) return;
      var delta = event.clientX - drag.startX;
      if (Math.abs(delta) > 4) drag.moved = true;
      if (drag.moved) {
        track.classList.add('is-dragging');
        track.scrollLeft = drag.startLeft - delta;
      }
    });
    function endDrag() {
      if (!drag.active) return;
      var shouldSnap = drag.moved;
      drag.active = false;
      track.classList.remove('is-dragging');
      if (shouldSnap) scrollTo(currentIndex());
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', function () {
      if (drag.active) endDrag();
    });
    syncDots();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
